import DataModal from './DataModal';

export default DataModal;
